import axios from "axios";
import { api as Api } from "api/http";

// Cache configuration
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes in milliseconds
const cache = new Map();

// Cache utility functions
const generateCacheKey = (type, identifier) => {
    return `${type}_${identifier}`;
};

const isCacheValid = (cacheEntry) => {
    return Date.now() - cacheEntry.timestamp < CACHE_TTL;
};

const getFromCache = (key) => {
    const cacheEntry = cache.get(key);
    if (cacheEntry && isCacheValid(cacheEntry)) {
        return cacheEntry.data;
    }
    if (cacheEntry) {
        cache.delete(key); // Remove expired cache entry
    }
    return null;
};

const setCache = (key, data) => {
    cache.set(key, {
        data,
        timestamp: Date.now()
    });
};

// Cache management functions
export const clearImageCaptionCache = () => {
    cache.clear();
};

export const getCacheSize = () => {
    return cache.size;
};

export const getImageAICaptionFile = async (file) => {
    // Generate cache key based on file properties
    const fileKey = `${file.name}_${file.size}_${file.lastModified}`;
    const cacheKey = generateCacheKey('file', fileKey);
    
    // Check cache first
    const cachedResult = getFromCache(cacheKey);
    if (cachedResult) {
        return cachedResult;
    }

    // If not in cache, make API call
    var formData = new FormData();
    formData.append('image', file);
    const result = await Api.post(`/microsoft/imageCaption`, {}, formData).then(({ data }) => {
        let caption = data?.captionResult?.text;
        let text = data?.readResult?.content;
        return `${caption} ${text ? ` with the text "${text}"` : ``}`;
    });
    
    // Cache the result
    setCache(cacheKey, result);
    return result;
} 

export const getImageAICaptionURL = async (url) => {
    // Generate cache key based on URL
    const cacheKey = generateCacheKey('url', url);
    
    // Check cache first
    const cachedResult = getFromCache(cacheKey);
    if (cachedResult) {
        return cachedResult;
    }

    // If not in cache, make API call
    const result = await Api.get(`/openai/imageCaption?url=${url}`).then(({ data }) => {
        return data;
    });
    
    // Cache the result
    setCache(cacheKey, result);
    return result;
} 

export const getImageAICaptionURLAzure = async (url) => {
    // Generate cache key based on URL
    const cacheKey = generateCacheKey('url_azure', url);
    
    // Check cache first
    const cachedResult = getFromCache(cacheKey);
    if (cachedResult) {
        return cachedResult;
    }

    // If not in cache, make API call
    const result = await Api.post(`/microsoft/imageCaption`, {}, { url: url }).then(({ data }) => {
        let caption = data?.captionResult?.text;
        let text = data?.readResult?.content;
        return `${caption} ${text ? ` with the text "${text}"` : ``}`;
    });
    
    // Cache the result
    setCache(cacheKey, result);
    return result;
} 